export const STORAGE_KEYS = {
  PERSIST_ROOT: "persist:envella-root",
  AUTH_COOKIE: "envella_access_token",
  PENDING_VERIFICATION: "envella_pending_verification",
  SIGNUP_PROPERTY_DRAFT: "envella_signup_property_draft",
  /** User dismissed first-property onboarding; do not force /signup/property again this session */
  SKIP_PROPERTY_ONBOARDING: "envella_skip_property_onboarding",
} as const;
